module.exports = __webpack_public_path__ + "static/media/Walkman Snail Shoes.67db714a.jpg";